import './module/common';
import './module/slick';
import './module/magnificpopup';
import './module/menu';
import './module/accordion';
import './module/script';


